import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { ClarityTracking } from '@/analytics/ClarityTracking';
import { useActivityHeartbeat, useGuestVisit, useRouteTelemetry } from '@/analytics/session';
import { useAuth } from '@/auth/AuthProvider';
import { useSubscribeIntent } from '@/billing/useSubscribeIntent';
import { CrispChat } from '@/integrations/CrispChat';

/** Корень роутера: телеметрия маршрутов, Clarity и намерение подписки живут выше auth-гейта (TRK-3, TRK-7, BILL-3). */
export function RootLayout() {
  const { isAuthenticated } = useAuth();
  useRouteTelemetry(isAuthenticated);
  useGuestVisit(isAuthenticated);
  useActivityHeartbeat(isAuthenticated);
  // Намерение подписки с лендинга живёт выше auth-гейта — переживает вход и код (BILL-3).
  useSubscribeIntent();
  useTrailingSlashOnRoot();

  return (
    <>
      <ClarityTracking />
      <CrispChat />
      <Outlet />
    </>
  );
}

/**
 * Роутер режет завершающий слэш у basename: после navigate('/') адрес становится `/app`,
 * и перезагрузка такой страницы упирается в сервер (Vite: «did you mean /app/»). Возвращаем
 * `/app/` через replaceState — роутер слушает только popstate, его состояние не меняется.
 */
function useTrailingSlashOnRoot(): void {
  const location = useLocation();
  useEffect(() => {
    const base = import.meta.env.BASE_URL.replace(/\/$/, '');
    if (base && window.location.pathname === base) {
      window.history.replaceState(
        window.history.state,
        '',
        `${base}/${window.location.search}${window.location.hash}`,
      );
    }
  }, [location]);
}
